module.exports = "/assets/723e177f56688a03edd15fa9d8fddde2.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/OM.png
// module id = 1685
// module chunks = 0